import { createContext, useContext } from "react";

// Opens the app-wide dialer sheet (mobile). Provided by DashboardPage so the
// tab bar's call FAB and any page's "New call" action share one dialer.
export const DialerContext = createContext<{ openDialer: () => void }>({
  openDialer: () => {},
});

export function useDialer() {
  return useContext(DialerContext);
}
